<template>
  <div class="message-dropdown-content">
    <section class="main-content">
      <div
        class="is-flex is-justify-content-space-between mb-10"
        :class="{ 'custom-nav': isCollapse }"
      >
        <h1
          class="is-6 has-text-weight-semibold is-flex"
          :class="{ 'cursor-pointer': isCollapse }"
          :role="isCollapse ? 'button' : ''"
          @click="toggleCollapse()"
        >
          <b-icon v-if="isCollapse" icon="arrow-left"></b-icon>
          <span> {{ General.TEXTS.MESSAGE }} </span>
        </h1>
        <div
          v-if="getListMessage.length"
          role="button"
          type="is-text is-white"
          class="cursor-pointer is-underlined"
          @click="confirmReadAll"
        >
          {{ General.TEXTS.MARK_ALL_READ_2 }}
        </div>
      </div>

      <div class="message-wrapper">
        <template v-if="getListMessage.length">
          <div v-for="(message, index) in getListMessage" :key="index">
            <div
              class="message-card has-text-color-7"
              :class="{ 'notification-readed': message.is_readed }"
              @click="readedMessage(message)"
            >
              <div class="message-content mb-5">
                <div class="has-text-weight-semibold">
                  {{ message.title }}
                </div>
                <div class="has-text-weight-semibold word-break-normal">
                  {{ new Date(message.created_at) | dateFormat("DD/MM/YYYY") }}
                </div>
              </div>

              <div>
                {{ message.description }}
              </div>
            </div>
          </div>
        </template>
        <template v-else
          ><p class="is-flex is-justify-content-center has-text-color-7 my-20">
            {{ App.MessagesAreaScreen.NONE_MESSAGE }}
          </p>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { General, App } from "@/utils/constants";

export default {
  name: "MessageHeaderContent",
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    },
    toggleCollapse: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      General,
      App
    };
  },
  computed: {
    ...mapGetters({
      getListMessage: "getListMessage"
    })
  },
  async beforeMount() {
    await this.listMessages();
  },
  methods: {
    ...mapActions({
      listMessages: "listMessages",
      readMessage: "readMessage",
      readAllMessage: "readAllMessage"
    }),

    ...mapMutations({
      setUnreadMessageCount: "setUnreadMessageCount"
    }),

    async confirmReadAll() {
      const status = await this.readAllMessage();
      if (status) {
        await this.listMessages();
        this.setUnreadMessageCount(0);
      }
    },

    async readedMessage(message) {
      if (!message.is_readed) await this.readMessage(message.id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.message-dropdown-content {
  width: 500px;
  max-width: 75vw;

  @media screen and (max-width: $tablet) {
    width: 100%;
    max-width: none;
  }

  .main-content {
    padding: 15px;
    padding-bottom: 0;

    .custom-nav {
      background-color: $background-color;
      margin: -15px;
      padding: 15px;
    }

    .message-wrapper {
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;

      .message-card {
        background-color: $background-color;
        border-radius: 5px;
        padding: 10px;
        margin: 10px 0;
        cursor: pointer;
        -ms-word-break: break-all;
        word-break: break-all;

        /* Non standard for WebKit */
        word-break: break-word;

        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        hyphens: auto; /* Optional */
        &:hover {
          color: $primary;
        }

        .message-content {
          display: flex;
          gap: 5px;
          justify-content: space-between;
        }

        .word-break-normal {
          word-break: normal;
        }
      }

      .notification-readed {
        background-color: $background-light;
        border: 1px solid $background-color;
      }
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/variables.scss";
.notification-tabs .tabs li.is-active a {
  border-bottom-color: $color-7;
}

.notification-dropdown .dropdown-content {
  padding-bottom: 0;

  .tab-content {
    padding: 1rem 0;
  }
}
</style>
